"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHYSICAL_STORE_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var StoreAddressFragment_1 = require("./StoreAddressFragment");
exports.PHYSICAL_STORE_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment PhysicalStore on Store {\n    id\n    name\n    category\n    modified\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"], ["\n  fragment PhysicalStore on Store {\n    id\n    name\n    category\n    modified\n    image {\n      id\n      url\n    }\n    address {\n      ...StoreAddress\n    }\n  }\n  ", "\n"])), StoreAddressFragment_1.STORE_ADDRESS_FRAGMENT);
var templateObject_1;
